// import "./index.scss";
import { useContext } from "react";
import utility from "src/utils/utility";
import UserContext from "src/provider/state-manager/userProvider";
import { MemberTypeEnum } from "src/model";
import { ResetPasswordModal } from "src/component/ResetPassword";

const ResetPassword = () => {
  const { user } = useContext(UserContext);

  return (
    <div className="dashboard-view-result">
      {user?.profile?.memberType === MemberTypeEnum.ADMIN ? (
        <ResetPasswordModal />
      ) : null}
    </div>
  );
};

export default utility.routeData(
  "reset-password",
  "Reset Password",
  <ResetPassword />
);
